import styled, { keyframes } from 'styled-components';

const shake = keyframes`
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
`;

export const StyledModal = styled.div`
  background-color: ${(p) => p.theme.alias.bg};
  border-radius: ${(p) => p.theme.space[3]};
  width: 480px;
  overflow: ${(p) => (p.showScrollbar ? 'auto scroll' : 'auto')};
  max-height: calc(100vh - 64px);
  height: 480px;
  margin: ${(p) => p.theme.space[6]} ${(p) => p.theme.space[0]};
  animation: ${(p) => p.shake && shake} 0.5s infinite;

  @media (max-width: 500px) {
    width: 100%;
    margin: 0;
    bottom: 0;
    position: absolute;
    border-radius: ${(p) => p.theme.space[3]} ${(p) => p.theme.space[3]} 0 0;
  }
`;
